import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import BranchManager from './pages/BranchManager';
import Driver from './pages/Driver';
import PaymentPortal from './pages/PaymentPortal';
import CashierPortal from './pages/CashierPortal';
import SalesForm from './pages/SalesForm';
import SalesHistory from './pages/SalesHistory';
import SalesDetails from './pages/SalesDetails';
import AdminDashboard from './pages/AdminDashboard';
import AdminDrivers from './pages/AdminDrivers';
import AdminOrders from './pages/AdminOrders';
import AdminReports from './pages/AdminReports';
import AdminUsers from './pages/AdminUsers';
import AdminLayout from './pages/AdminLayout';
import Login from './pages/Login';
import Home from './components/Home';
import AdminDriverCreation from './pages/AdminDriverCreation';
import AdminBranchCreation from './pages/AdminBranchCreation';
import AdminVendorCreation from './pages/AdminVendorCreation';
import AdminVendors from './pages/AdminVendors';
import AdminCustomerCreation from './pages/AdminCustomerCreation';
import AdminBranches from './pages/AdminBranches';
import AdminCustomers from './pages/AdminCustomers';
import AdminPayAndCollect from './pages/AdminPayAndCollect';
import SalesFormOrderTrack from './pages/SalesFormOrderTrack';
import PublicTracking from './components/PublicTracking';
import PublicTrackingPage from './components/PublicTrackingPage';
import ReportsLayout from './pages/ReportsLayout';
import AllOrdersReport from './pages/AllOrdersReport';
import DriversReport from './pages/DriversReport';
import VendorsReport from './pages/VendorsReport';
import CustomersReport from './pages/CustomersReport';
import PaymentsReport from './pages/PaymentsReport';
import CollectionsReport from './pages/CollectionsReport';

import Reports from './pages/Reports';

function App() {
  return (
    <div className='App'>
      <Router>
        <div>
          <Routes>
            {/* Login */}
            <Route path='/' element={<Login />} />

            {/* SalesForm + nested routes */}
            <Route path='SalesForm' element={<SalesForm />} />

            <Route path='SalesFormOrderTrack' element={<SalesFormOrderTrack />} />
			
            {/* Other Sales pages */}
            <Route path='SalesHistory/:orderId' element={<SalesHistory />} />
            <Route path='SalesDetails' element={<SalesDetails />} />

            {/* Portals */}
            <Route path='BranchManager' element={<BranchManager />} />
            <Route path='PaymentPortal' element={<PaymentPortal />} />
            <Route path='CashierPortal' element={<CashierPortal />} />
            <Route path='Driver' element={<Driver />} />

            {/* Public tracking routes */}
            <Route path='/track/:orderId' element={<PublicTrackingPage />} />
            <Route path='/track-order/:orderId' element={<PublicTracking />} />

            {/* Admin Layout and subpages */}
            <Route path='Dashboard' element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path='orders' element={<AdminOrders />} />
              <Route path='drivers' element={<AdminDrivers />} />
              <Route path='drivers/create' element={<AdminDriverCreation />} />
              <Route path='vendors' element={<AdminVendors />} />
              <Route path='vendors/create' element={<AdminVendorCreation />} />
              <Route path='customers' element={<AdminCustomers />} />
              <Route path='pay-and-collect' element={<AdminPayAndCollect />} />
              <Route
                path='customers/create'
                element={<AdminCustomerCreation />}
              />
              <Route path='branches' element={<AdminBranches />} />
              <Route path='branches/create' element={<AdminBranchCreation />} />
              <Route path='users' element={<AdminUsers />} />
              <Route path='reports' element={<ReportsLayout />}>
                <Route index element={<AllOrdersReport />} />
                <Route path='all-orders' element={<AllOrdersReport />} />
                <Route path='drivers' element={<DriversReport />} />
                <Route path='vendors' element={<VendorsReport />} />
                <Route path='customers' element={<CustomersReport />} />
                <Route path='payments' element={<PaymentsReport />} />
                <Route path='collections' element={<CollectionsReport />} />
              </Route>
            </Route>			
            <Route path='new-reports' element={<Reports />} />
          </Routes>
        </div>
      </Router>
    </div>
  );
}

export default App;